<template>
  <div class="row mb-4">
    <FormInput
      :autofocus="true"
      :required="true"
      label="Forename"
      name="firstname"
      autocomplete="given-name"
      placeholder="e.g. Jack"
      @input="update"
      v-model="value.forename"
    ></FormInput>
    <FormInput
      label="Surname"
      name="lastname"
      autocomplete="lname family-name"
      placeholder="e.g. Smith"
      @input="update"
      v-model="value.surname"
    ></FormInput>
    <FormInput
      pattern="^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$"
      type="email"
      label="Email"
      name="email"
      :required="true"
      autocomplete="email"
      placeholder="e.g. jack@myemail.com"
      @input="update"
      v-model="value.email"
    ></FormInput>
    <FormInput
      :required="true"
      type="password"
      label="Account Password"
      name="password"
      autocomplete="new-password"
      @input="update"
      v-model="value.password"
    ></FormInput>
  </div>
</template>
<script>
import FormInput from "@/components/form/FormInput";

export default {
  components: { FormInput },
  props: ["value"],
  methods: {
    update: function() {
      this.$emit("input", this.$props.value);
    }
  }
};
</script>